import React from 'react';
import { connect } from 'react-redux'

import AlertBanner from 'components/alerts/alert-banner'
import SmoothCollapse from 'react-smooth-collapse'

import {
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import { MainContext } from 'context'

import Todos from 'layout/header/header-tabs/todos'

const SingleTaskCheckList = props => {
    const {
        userData,
        accountData,
        taskObject,
        checklistItems,
        isArchived,
        isProjectEditable
    } = props

    return (
        <div>
            <div className="checklist">
                <SmoothCollapse 
                    expanded={!checklistItems.length}
                    allowOverflowWhenOpen={true}
                >
                    <AlertBanner 
                        low={true} 
                        title={'This checklist is empty.'} 
                        body={"Add steps for a task here."} 
                    />
                </SmoothCollapse>
                <Todos
                    isActive={true}
                    isChecklist={true}
                    checklistItems={checklistItems}
                    closeCallback={_ => {}}
                    currentAccount={accountData}
                    userData={userData}
                    tabName={'Test'}
                    task={taskObject}
                    isDisabled={isArchived || !isProjectEditable}
                />
            </div>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        userData: getCurrentUser(state),
        accountData: getCurrentAccount(state),
        allChecklistItems: state.account.entities.checklist_items,
    }
}

export default connect(mapStateToProps, { 
    
 })(SingleTaskCheckList)

SingleTaskCheckList.contextType = MainContext